import React, { FC, useMemo } from "react";
import { RouterParamType } from "@/model/navModel";
import { YhBox } from "@/components/YhBox";
import { Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useEntryDetailsModel } from "./stockEntryModelDetails";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";
import YhTootip from "@/components/YhTootip";
export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const { detailLookList } = useEntryDetailsModel()
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();

    const columns: ColumnsType<any> = [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            title: '配件编码',
            width: 120,
            dataIndex: 'materialCode',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '配件名称',
            width: 160,
            dataIndex: 'materialName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '所属库房',
            width: 160,
            dataIndex: 'warehouseName',
        }, {
            title: '所属货位',
            width: 160,
            dataIndex: 'shelfCode',
        }, {
            title: '数量',
            width: 160,
            dataIndex: 'num',
        }, {
            title: '单价',
            width: 120,
            dataIndex: 'price',
        },
        // {
        //     title: '折扣',
        //     width: 120,
        //     dataIndex: 'discountRate',
        // }, 
        {
            title: '总计',
            width: 120,
            dataIndex: 'amount',
        }
    ]

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "stockIn", "roleCodes": roles };
        return getRoleColumns("stockIn", "明细", columns, params);
    }, [roles, detailLookList]);

    return (
        <YhBox title="商品信息" style={{ height: 'calc(100vh - 320px)' }}>
            <Table
                bordered
                columns={roleColumns}
                dataSource={detailLookList}
                pagination={false}
                scroll={{ x: 'max-content', y: 'calc(100vh - 438px)' }}

            >
            </Table>
        </YhBox>
    )
}